import React from 'react'
import Headers from './components/Layout/Header'
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from 'react-router-dom'
import MenteeMain from './components/Mentee/Main/MenteeMain'
import styled from 'styled-components'
import MenteeTest from './components/Mentee/Test/MenteeTest'
import MenteeSearch from './components/Mentee/Search/MenteeSearch'
import MenteeRecommend from './components/Mentee/Recommend/MenteeRecommend'
import MenteeFriend from './components/Mentee/Friend/MenteeFriend'
import MenteeInvertory from './components/Mentee/Inventory/MenteeInventory'
import MenteeAuth from './components/Mentee/MenteeAuth'
import Login from './components/Login'
import HomeAuth from './components/HomeAuth'
import MentorAuth from './components/Mentor/MentorAuth'
import MentorMain from './components/Mentor/Main/MentorMain'
import MentorSearch from './components/Mentor/Search/MentorSearch'
import NotFound from './components/Error/NotFound'
import MentorMentee from './components/Mentor/Mentee/MentorMentee'
import MyPage from './components/Mentee/MyPage/MyPage'
import AdminAuth from './components/Admin/AdminAuth'
import AdminJobClass from './components/Admin/JobClass/AdminJobClass'
import AdminInstructor from './components/Admin/Instructor/AdminInstructor'
import MenteeJobClass from './components/Mentee/JobClass/MenteeJobClass'
import MentorJobClass from './components/Mentor/JobClass/MentorJobClass'
import JobDetail from './components/Common/JobDetail'
import AdminJobs from './components/Admin/JobClass/AdminJobs'
// import FloatMenu from './components/Common/FloatMenu'

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Container>
          <Headers />
          <Routes>
            <Route path="/mentee/" element={<MenteeAuth />}>
              <Route path="test" element={<MenteeTest />} />
              <Route path="test/:id" element={<MenteeTest />} />
              <Route path="search" element={<MenteeSearch />} />
              <Route path="recommend" element={<MenteeRecommend />} />
              <Route path="friend/:id?" element={<MenteeFriend />} />
              <Route path="inventory" element={<MenteeInvertory />} />
              <Route path="jobclass" element={<MenteeJobClass />} />
              <Route path="" element={<MenteeMain />} />
            </Route>
            <Route path="/mentor/" element={<MentorAuth />}>
              <Route path="mentee" element={<MentorMentee />} />
              <Route path="search" element={<MentorSearch />} />
              <Route path="jobclass" element={<MentorJobClass />} />
              <Route path="" element={<MentorMain />} />
            </Route>
            <Route path="/admin/" element={<AdminAuth />}>
              <Route path="instructor" element={<AdminInstructor />} />
              <Route path="jobclass" element={<AdminJobClass />} />
              <Route path="jobs/:page" element={<AdminJobs />} />
              <Route
                path="jobs"
                element={<Navigate replace to="/admin/jobs/0" />}
              />
            </Route>
            <Route path="/" element={<HomeAuth />} />
            <Route path="/login" element={<Login />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/job/:id" element={<JobDetail />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Container>
        {/* <FloatMenu /> */}
      </BrowserRouter>
    </div>
  )
}

const Container = styled.div`
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto;
  position: relative;
  margin-top: 70px;
  flex-direction: column;

  @media (max-width: 768px) {
    margin-top: 90px;
    padding-bottom: 200px;
  }
`
export default App
